import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidesPage from "../pages/guides/page";
import GuideDetailPage from "../pages/guides/detail/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guides",
    element: <GuidesPage />,
  },
  {
    path: "/guides/:slug",
    element: <GuideDetailPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;